export default {"src":"/_next/static/media/open_filled.cb24e060.svg","height":24,"width":24};